import type { en } from "@/i18n/en";

type Translations = typeof en;


export interface NavLink {
  label: string;
  href: string;
}

export interface NavGroup {
  label: string;
  children: NavLink[];
}

/**
 * Single source of truth for the main navigation.
 * Order: Productos, Soluciones, Recursos (incl. casos de éxito), Empresa.
 */
export function buildMainNav(t: Translations, language: "es" | "en" = "es"): NavGroup[] {
  const cols = t.footer.columns;
  const fromCols = (items: { name: string; href: string }[]): NavLink[] =>
    items.map((i) => ({ label: i.name, href: i.href }));
  const isEn = language === "en";

  return [
    {
      label: isEn ? "Products" : "Productos",
      children: [
        { label: "FONDEA", href: "/fondea" },
        { label: "SOLVENN", href: "/white-label" },
      ],
    },
    {
      label: t.nav.solutions,
      children: [
        { label: "Factoring", href: "/solutions/factoring" },
        { label: "Confirming", href: "/solutions/confirming" },
        { label: isEn ? "B2B payments" : "Pagos B2B", href: "/solutions/payments" },
        { label: isEn ? "Invoice auctions" : "Subastas de facturas", href: "/solutions/auctions" },
        { label: isEn ? "Invoice markets" : "Mercados de facturas", href: "/solutions/auctions" },
        { label: isEn ? "Integrations" : "Integraciones", href: "/solutions/integrations" },
      ],
    },
    {
      label: t.nav.resources,
      children: [
        { label: t.nav.resourceItems.caseStudies, href: "/resources/case-studies" },
        { label: t.nav.resourceItems.blog, href: "/resources/blog" },
        { label: t.nav.resourceItems.documentation, href: "/resources/documentation" },
        { label: t.nav.services, href: "/services/overview" },
      ],
    },
    { label: t.nav.company, children: fromCols(cols.company.items) },
  ];
}
